import React from 'react';
import AddService from '../AddService/AddService';




const Admin = () => {

    return (
        <div className="container">
            <AddService></AddService>
        </div>
    );
};

export default Admin;